import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Store } from '@ngxs/store';

import { AuthState } from '@data/state';

type AuthGuardOptions = {
  requiresAuthentication: boolean;
};

export const authGuard = (options: AuthGuardOptions): CanMatchFn => {
  return (_: Route, segments: UrlSegment[]) => {
    const router = inject(Router);
    const store = inject(Store);

    const isAuthenticated = store.selectSnapshot(AuthState.isAuthenticated);

    if (options.requiresAuthentication) {
      if (isAuthenticated) return true;

      return router.createUrlTree(['/auth/login'], {
        queryParams: { returnUrl: `/${segments.map((s) => s.path).join('/')}` },
      });
    }

    // Guest-only route (login, forgot/reset password) - signed-in users don't need it.
    if (isAuthenticated) {
      return router.createUrlTree(['/']);
    }

    return true;
  };
};
